import { IconTab } from "@/src/components/iconTab";
import { Intervention, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { openSnomedConceptPicker } from "../../snomed/SnomedConceptPicker";
import openEvolutionStandardForm from "../openEvolutionItemStandardForm";
import { LuSyringe } from "react-icons/lu";

function InterventionButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Intervention) => void;
}) {
  return (
    <IconTab
      id={"intervention"}
      activeTabId={null}
      isHorizontal={true}
      name={"Intervention"}
      icon={<LuSyringe size={22} />}
      onChange={async () => {
        await openSnomedConceptPicker({
          title: "Choisir une intervention",
          parentIds: ["procedure"],
          category: "intervention",
          onSelect: async (reference) => {
            let item: Intervention = {
              type: "intervention",
              patient,
              creator: getUserId(),
              parent,
              reference,
              content: {
                patient,
                creator: getUserId(),
                fieldAnswers: [],
                reference: null,
              },
              confidentiality: getStandardConfidentiality(patient),
              readBy: [getUserId()],
            };
            await openEvolutionStandardForm({
              item,
              patient,
              onConfirm: async (newItem) => {
                newItem = await apiFetch("interventions", "addOne", {
                  intervention: newItem,
                });
                onSave(newItem);
              },
            });
          },
        });
      }}
    />
  );
}

export default InterventionButton;
